import { Page } from '@/core/architecture'

import { ConsoleItemInformationTemplate } from './template'
import { useViewModel } from './viewModel'

export const ConsoleItemInformation: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleItemInformationTemplate state={state} {...actions} />
}
